// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import lisEntity from './entities/lis.json';
import lisMenu from '../pages/lis/menu.json';
import lisFullForm from '../pages/lis/forms/full.json';
import lisContextForm from '../pages/lis/forms/context.json';
import lisMiniForm from '../pages/lis/forms/mini.json';
import lisLookupForm from '../pages/lis/forms/lookup.json';
import lisTableView from '../pages/lis/views/table.json';
import lisStagesView from '../pages/lis/views/stages.json';
import lisCardsView from '../pages/lis/views/cards.json';
import lisInlineView from '../pages/lis/views/inline.json';
import lisBacklogView from '../pages/lis/views/backlog.json';
import lisSplitView from '../pages/lis/views/split.json';
import lisCalendarView from '../pages/lis/views/calendar.json';
import lisDashboardView from '../pages/lis/views/dashboard.json';

/** Тип запису «Проблема» зі сторінками пакета: меню, форми та подання з pages/lis/. */
export const lisDefinition: IRecordTypeDefinition = {
  ...lisEntity,
  views: assembleViewSet({
      table: lisTableView,
      stages: lisStagesView,
      cards: lisCardsView,
      inline: lisInlineView,
      backlog: lisBacklogView,
      split: lisSplitView,
      calendar: lisCalendarView,
      dashboard: lisDashboardView,
  }),
  form: lisFullForm,
  forms: { full: lisFullForm, context: lisContextForm, mini: lisMiniForm, lookup: lisLookupForm },
  menu: lisMenu,
} as IRecordTypeDefinition;
